import { mapConfigResponse } from './transforms';
export class ConfigService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    async get(params) {
        const { domains, configServiceOptions } = this.#storeClient.options;
        const configData = await this.#requestClient.fetch({
            url: `${domains.opml}/config.ashx`,
            params: {
                c: configServiceOptions.commands,
                ...params,
            },
            transform: mapConfigResponse(configServiceOptions),
            skipCamelCaseTransform: true,
        });
        this.#storeClient.configData = configData;
        return configData;
    }
}
